"use client";

import { useSearchParams, useRouter, usePathname } from "next/navigation";
import { Grid3x3, List, Clock } from "lucide-react";

export default function CompaniesToolbar() {
  const searchParams = useSearchParams();
  const router = useRouter();
  const pathname = usePathname();

  const currentSort = searchParams.get("sort") || "name-asc";
  const currentView = searchParams.get("view") || "grid";
  const isOpenNow = searchParams.get("open_now") === "true";

  const updateParam = (key: string, value: string) => {
    const params = new URLSearchParams(searchParams.toString());
    params.set(key, value);
    router.push(`${pathname}?${params.toString()}`);
  };

  const toggleOpenNow = () => {
    const params = new URLSearchParams(searchParams.toString());
    if (isOpenNow) {
      params.delete("open_now");
    } else {
      params.set("open_now", "true");
    }
    params.delete("page");
    router.push(`${pathname}?${params.toString()}`);
  };

  return (
    <div className="flex items-center justify-between gap-4 mb-6 p-4 bg-white rounded-lg border border-gray-200">
      <div className="flex items-center gap-3">
        {/* Open Now Filter Chip */}
        <button
          onClick={toggleOpenNow}
          className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium transition-colors ${
            isOpenNow
              ? "bg-mygreen text-white"
              : "bg-gray-100 text-gray-700 hover:bg-gray-200"
          }`}
        >
          <Clock className="w-4 h-4" />
          <span>Aberto Agora</span>
        </button>

        {/* Sort */}
        <div className="flex items-center gap-3">
          <span className="text-sm text-gray-600">Ordenar por:</span>
          <select
            value={currentSort}
            onChange={(e) => updateParam("sort", e.target.value)}
            className="px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-mygreen/20"
          >
            <option value="name-asc">Nome (A-Z)</option>
            <option value="name-desc">Nome (Z-A)</option>
            <option value="popular">Mais Populares</option>
            <option value="recent">Mais Recentes</option>
          </select>
        </div>
      </div>

      {/* View Mode */}
      <div className="flex items-center gap-2">
        <button
          onClick={() => updateParam("view", "grid")}
          className={`p-2 rounded-lg transition-colors ${
            currentView === "grid"
              ? "bg-mygreen text-white"
              : "bg-gray-100 text-gray-600 hover:bg-gray-200"
          }`}
          aria-label="Visualização em grade"
        >
          <Grid3x3 className="w-5 h-5" />
        </button>
        <button
          onClick={() => updateParam("view", "list")}
          className={`p-2 rounded-lg transition-colors ${
            currentView === "list"
              ? "bg-mygreen text-white"
              : "bg-gray-100 text-gray-600 hover:bg-gray-200"
          }`}
          aria-label="Visualização em lista"
        >
          <List className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
}
